import { render, staticRenderFns } from "./chatbot.vue?vue&type=template&id=a475cb98"
import script from "./chatbot.vue?vue&type=script&lang=js"
export * from "./chatbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports